import gql from "graphql-tag";

export default gql`
mutation activityCancelSignupScreen ($profile: ScreenProfile!, $subscription: ActivitySubscription!) {
  activityCancelSignupScreen (profile: $profile, subscription: $subscription) {
        id,
        success,
        message
    }
}`